// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splash-min-width[data-v-03305a12] {
  min-width: 505px;
}
.nav-container[data-v-03305a12] {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--03305a12-\\\$getStyles\\.backgroundColor);
}
.nav-bar[data-v-03305a12] {
  width: 100%;
  padding: 0 20px;
  overflow: auto;
}
[data-v-03305a12] .row.join-waitlist-button .i-text {
  font-weight: 700 !important;
}
[data-v-03305a12] .row.join-waitlist-button .i-text:hover {
  font-weight: 700 !important;
}
@media (max-width: 768px) {
.nav-bar[data-v-03305a12] {
    padding: 0 20px;
}
.nav-bar .nav-fill[data-v-03305a12] {
    display: none;
}
.nav-bar .button-container[data-v-03305a12] {
    gap: 0;
}
.nav-bar[data-v-03305a12] .i-button {
    width: min-content;
    white-space: nowrap;
}
}
[data-v-03305a12] .i-text {
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/splash/SplashWrapper.vue","webpack://./SplashWrapper.vue","webpack://./src/Web/scripts/styles/breakpoint-mixin.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;ACDF;ADIA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,8DAAA;ACDF;ADIA;EACE,WAAA;EACA,eAAA;EACA,cAAA;ACDF;ADIA;EACE,2BAAA;ACDF;ADGE;EACE,2BAAA;ACDJ;ACrBE;AF2BA;IACE,eAAA;ACFF;ADIE;IACE,aAAA;ACFJ;ADKE;IACE,MAAA;ACHJ;ADME;IACE,kBAAA;IACA,mBAAA;ACJJ;AACF;ADQA;EACE,iBAAA;ACNF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.splash-min-width {\n  min-width: 505px;\n}\n\n.nav-container {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: v-bind(\"$getStyles.backgroundColor\");\n}\n\n.nav-bar {\n  width: 100%;\n  padding: 0 20px;\n  overflow: auto;\n}\n\n:deep(.row.join-waitlist-button .i-text) {\n  font-weight: 700 !important; // TODO: remove just temporary\n\n  &:hover {\n    font-weight: 700 !important; // TODO: remove just temporary\n  }\n}\n\n@include phone {\n  .nav-bar {\n    padding: 0 20px;\n\n    .nav-fill {\n      display: none;\n    }\n\n    .button-container {\n      gap: 0;\n    }\n\n    :deep(.i-button) {\n      width: min-content;\n      white-space: nowrap;\n    }\n  }\n}\n\n:deep(.i-text) {\n  overflow: visible;\n}\n",".splash-min-width {\n  min-width: 505px;\n}\n\n.nav-container {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: v-bind(\"$getStyles.backgroundColor\");\n}\n\n.nav-bar {\n  width: 100%;\n  padding: 0 20px;\n  overflow: auto;\n}\n\n:deep(.row.join-waitlist-button .i-text) {\n  font-weight: 700 !important;\n}\n:deep(.row.join-waitlist-button .i-text):hover {\n  font-weight: 700 !important;\n}\n\n@media (max-width: 768px) {\n  .nav-bar {\n    padding: 0 20px;\n  }\n  .nav-bar .nav-fill {\n    display: none;\n  }\n  .nav-bar .button-container {\n    gap: 0;\n  }\n  .nav-bar :deep(.i-button) {\n    width: min-content;\n    white-space: nowrap;\n  }\n}\n:deep(.i-text) {\n  overflow: visible;\n}","@mixin phone {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media (max-width: 1365px) {\n    @content;\n  }\n}\n\n@mixin desktop {\n  @media (min-width: 1366px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
